import { Routes as Router, Route } from 'react-router-dom'
import { Loader } from '@crossfit/ui'
import DashboardPage from 'pages/Dashboard'
import PlaybookPage from 'pages/Playbook'
import ContentKitPage from 'pages/ContentKit'
import PricingPage from 'pages/Pricing'
import RoundtablesPage from 'pages/Roundtables'
import Programming from 'pages/Programming'
import PartnerNetworkPage from 'pages/PartnerNetwork'
import StarterKitPage from 'pages/StarterKit'
import AdminContainer from 'components/Admin/Shared/Menu/Shared/Admin'
import ContactInfo from 'pages/Admin/ContactInfo'
import ReviewInvitePage from 'pages/TeamManagement/ReviewInvite'
import Redirect from 'pages/Redirect'
import LogoutPage from 'pages/Logout'
import AuthorizedApp from 'components/App/Routes/Authorized'
import Staff from 'pages/Admin/Staff'
import InviteTeammatePage from 'pages/TeamManagement/Invite'
import DirectoryPage from 'pages/Admin/DirectoryPage'
import DynamicPage from 'pages/Dynamic'
import { AccessPortal } from 'components/App/Routes/AccessPortal'
import { useAffiliate } from 'hooks/useAffiliate'

export default function Routes() {
  const { isLoading } = useAffiliate()

  if (isLoading) {
    return <Loader />
  }

  return (
    <Router>
      <Route path='/' element={<AuthorizedApp />}>
        <Route
          path='/'
          element={AccessPortal(<DashboardPage />, 'dashboard')}
        />
        <Route
          path='dashboard'
          element={AccessPortal(<DashboardPage />, 'dashboard')}
        />
        <Route
          path='playbook'
          element={AccessPortal(<PlaybookPage />, 'playbook')}
        />
        <Route
          path='marketing'
          element={AccessPortal(<ContentKitPage />, 'marketing')}
        />
        <Route
          path='affiliate-pricing'
          element={AccessPortal(<PricingPage />, 'affiliate-pricing')}
        />
        <Route
          path='roundtables'
          element={AccessPortal(<RoundtablesPage />, 'roundtables')}
        />
        <Route
          path='programming/*'
          element={AccessPortal(<Programming />, 'programming/*')}
        />
        <Route
          path='partner-network'
          element={AccessPortal(<PartnerNetworkPage />, 'partner-network')}
        />
        <Route
          path='starter-kit'
          element={AccessPortal(<StarterKitPage />, 'starter-kit')}
        />
        <Route path='/*' element={<DynamicPage />} />
        <Route path='admin'>
          <Route element={AccessPortal(<AdminContainer />, 'admin')}>
            <Route
              path='directory-page'
              element={AccessPortal(<DirectoryPage />, 'directory-page')}
            />
            <Route
              path='contact-info'
              element={AccessPortal(<ContactInfo />, 'contact-info')}
            />
            <Route
              path='staff'
              element={AccessPortal(<Staff staffType={'active'} />, 'staff')}
            />
            <Route
              path='staff/review/*'
              element={AccessPortal(<ReviewInvitePage />, 'staff/review/*')}
            />
            <Route
              path='staff/invite'
              element={AccessPortal(<InviteTeammatePage />, 'staff/invite')}
            />
            <Route
              path='staff/pending'
              element={AccessPortal(
                <Staff staffType={'pending'} />,
                'staff/pending',
              )}
            />
          </Route>
        </Route>
      </Route>
      <Route path='/logout' element={<LogoutPage />} />
      <Route path='/redirect' element={<Redirect />} />
    </Router>
  )
}
